$(function(){
	$('.key-visual .slick-box .slick-ul').slick({
		arrows: false,
		dots: false,
		fade: true,
		autoplay: true,
		pauseOnHover: false,
		pauseOnFocus: false,
		speed: 3000,
	});

	new SimpleBar($('.scroll-box')[0]);
});